import { useSearchParams } from "react-router-dom"

export interface PreviewMode {
  previewHash: string | null
  isPreviewActive: boolean
  previewBundleUrl: string | null
}

export function usePreviewMode(): PreviewMode {
  const [searchParams] = useSearchParams()
  const hash = searchParams.get("preview")

  if (!hash) {
    return { previewHash: null, isPreviewActive: false, previewBundleUrl: null }
  }

  const previewBundleUrl = `https://hydrologiq-prod-dashboard.s3.eu-west-2.amazonaws.com/sections/pr/${hash}/sections.js`

  return { previewHash: hash, isPreviewActive: true, previewBundleUrl }
}
